import { AppNS } from 'app';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import BasicAutocomplete from 'app/ui_v2/form-fields/basic-fields/autocomplete/BasicAutocomplete';
import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getSearchValues } from '../helpers';

export interface UsersAutocompleteProps {
  control: any;
  disabled?: boolean;
  inputName: string;
  subjectType: AppNS.SubjectType | '';
  onValueChange: (value: AppNS.Params) => void;
  isReset: number;
}

let timeout: number;

export default function UsersAutocomplete(props: UsersAutocompleteProps) {
  const { control, disabled = false, inputName, subjectType, onValueChange, isReset } = props;

  const [value, setValue] = useState<string>('');
  const [fetchedData, setFetchedData] = useState<{ id: string; name: string }[]>([]);
  const queryKey = ['get-companies-autocomplete', value];

  const placeholder = subjectType === 'inspector' ? 'Search for inspectors' : 'Search for agencies';

  const { isFetching, isError, error, data, isSuccess } = useQuery({
    queryKey,
    queryFn: ({ signal }) => getSearchValues(value, subjectType, signal),
    enabled: Boolean(value) && subjectType !== '',
    keepPreviousData: true,
  });

  const handleInputChange = (v: string) => {
    clearTimeout(timeout);
    if (!v) {
      setValue('');
      return;
    }

    if (v.length < 3) {
      return;
    }
    timeout = window.setTimeout(() => {
      //  set debounce on changes
      setValue(v);
    }, 400);
  };

  useEffect(() => {
    if (isReset) {
      setFetchedData([]);
    }
  }, [isReset]);

  useEffect(() => {
    if (data) {
      setFetchedData(data);
    }
  }, [isSuccess, data]);

  return (
    <>
      <BasicAutocomplete
        collection={fetchedData}
        label="Subject"
        inputName={inputName}
        control={control}
        onInputChange={handleInputChange}
        isLoading={isFetching}
        placeholder={subjectType ? placeholder : 'Pick subject type first'}
        disabled={disabled}
        onValueChange={onValueChange}
      />
      {isError && error && <ErrorsList title="Unexpected loading error" errors={error as string[]} />}
    </>
  );
}
